import { Button as AntdButton } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button';

type ButtonVariant = 'primary' | 'secondary';

type ButtonProps = {
  children?: React.ReactNode;
  variant?: ButtonVariant;
  fullWidth?: boolean;
} & Omit<AntdButtonProps, 'children' | 'variant'>;

const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', fullWidth = false, ...otherProps }) => {
  const baseStyles = 'text-center text-base font-semibold leading-6 px-5 py-2 rounded-lg font-figtree';
  const widthStyles = fullWidth ? 'max-sm:w-full' : '';

  const variantStyles: Record<ButtonVariant, string> = {
    primary: 'text-white bg-[#000032]',
    secondary: 'text-[rgba(0,0,0,0.85)] bg-white border border-[#D9D9D9]',
  };

  return (
    <AntdButton className={`${baseStyles} ${variantStyles[variant]} ${widthStyles}`} {...otherProps}>
      {children}
    </AntdButton>
  );
};

export default Button;
